module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    ref: "statelineRef",
    staticClass: "rt-stateline",
    class: _vm.computedStatelineClass
  }, [_vm._t("default"), _vm._v(" "), (!_vm.roll && _vm.direction === 'vertical' && _vm.steps.length > _vm.displayCount) ? _c('rt-button-more', {
    attrs: {
      "expanded-suffix-icon": _vm.computedShowSuffixIcon,
      "collapsed-suffix-icon": _vm.computedShowSuffixIcon,
      "button-color": _vm.buttonColor
    },
    on: {
      "change": _vm.changeExpand
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af5bfa4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/stateline/rtStateline.vue
// module id = 2212
// module chunks = 137